import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color } = baseVariables;

export const StyledToolbarItem = styled.div`
  position: relative;
  display: inline-block;
`;

export const StyledToolbarButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${toRem(6)};
  padding: ${toRem(4)} ${toRem(8)};
  height: ${toRem(28)};
  min-width: auto;
  border: none;
  background: transparent;
  border-radius: ${toRem(4)};
  color: inherit;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background: ${color.bvyAccent40};
    outline: none;
  }

  .toolbar-btn-icon {
    display: inline-flex;
    align-items: center;
  }

  .toolbar-btn-label {
    display: inline-block;
  }

  .toolbar-btn-Chevron {
    font-size: ${toRem(10)};
    opacity: 0.7;
  }
`;

export const StyledToolbarMenu = styled.div`
  position: absolute;
  top: calc(100% + ${toRem(4)});
  left: 0;
  z-index: 1000;
  min-width: ${toRem(170)};
  background: ${color.alert10};
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: ${toRem(6)};
  box-shadow: 0 ${toRem(4)} ${toRem(10)} rgba(0, 0, 0, 0.12);
  padding: ${toRem(4)};

  .toolbar-menu-item {
    width: 100%;
    display: grid;
    grid-template-columns: ${toRem(16)} 1fr ${toRem(14)};
    align-items: center;
    gap: ${toRem(8)};
    padding: ${toRem(6)} ${toRem(8)};
    background: transparent;
    border: none;
    border-radius: ${toRem(4)};
    cursor: pointer;
    text-align: left;

    &:hover,
    &:focus-visible {
      background: rgba(0, 0, 0, 0.06);
      outline: none;
    }

    &.is-selected {
      background: ${color.bvyAccent40};
    }
  }

  .toolbar-menu-icon {
    display: inline-flex;
    align-items: center;

    svg {
      display: block;
    }
  }

  .toolbar-menu-label {
    display: inline-block;
  }
`;

export const StyledToolbarDialog = styled.div`
  position: absolute;
  top: calc(100% + ${toRem(4)});
  left: 0;
  z-index: 1000;
  width: ${toRem(320)};
  max-width: 90vw;
  background: ${color.alert10};
  border: ${toRem(1)} solid rgba(0, 0, 0, 0.08);
  border-radius: ${toRem(6)};
  box-shadow: 0 ${toRem(4)} ${toRem(10)} rgba(0, 0, 0, 0.12);
  padding: ${toRem(12)};
`;
